module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D11-clean-b4f96e3f4204eb57d541ad4ace658e26.png";